module.exports = __webpack_public_path__ + "static/media/app-produtos-edit.a8ac256f.png";